import {config} from 'config/env';
import {apiVersion} from 'constants/recommendation';
import getClient from 'utils/appollo-client';

const userApolloClient = getClient(config.USER_API_ENDPOINT);

const campaignApolloClientWithToken = (idToken: string) => {
  return getClient(config.CAMPAIGN_SERVICE_URL, idToken);
};

const checkoutApolloClientWithToken = (idToken?: string) => {
  return getClient(config.CHECKOUT_API_ENDPOINT, idToken);
};

const userApolloClientWithToken = (idToken: string) => {
  return getClient(config.USER_API_ENDPOINT, idToken);
};

const addressApolloClientWithToken = (idToken: string) => {
  return getClient(config.BACKEND_API_ENDPOINT, idToken);
};

const loyaltyApolloClientWithToken = (idToken: string) => {
  return getClient(config.CAMPAIGN_SERVICE_URL, idToken);
};

const basketApolloClientWithToken = (idToken?: string) => {
  return getClient(config.BASKET_API_ENDPOINT, idToken);
};
const productApolloClient = () => {
  return getClient(`${config.PRODUCT_API_ENDPOINT}${apiVersion}`);
};

const productApolloClientWithToken = (idToken?: string) => {
  return getClient(`${config.PRODUCT_API_ENDPOINT}${apiVersion}`, idToken);
};

export {
  userApolloClient,
  userApolloClientWithToken,
  checkoutApolloClientWithToken,
  addressApolloClientWithToken,
  loyaltyApolloClientWithToken,
  productApolloClient,
  basketApolloClientWithToken,
  productApolloClientWithToken,
  campaignApolloClientWithToken
};
